<!--
  Chart.js sizing box (Bug #234): `w-full` is Tailwind, `w-100` was BOOTSTRAP (`width:100%!important`).
  The canvas below already used the Tailwind name. `h-[32rem]` must stay on this element — Chart.js reads the
  canvas's PARENT to size the doughnut.
-->
<div class="w-full h-[32rem] p-2 flex justify-content-center">
  @if (timeSeriesPerformanceStore.analysisErrorState) {
    @switch (timeSeriesPerformanceStore.analysisErrorState) {
      @case (ErrorAnalysis.loading) {
        <div
          class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          role="status">
        </div>
      }
      @default {
        <!-- Error panel, not a chart box: `w-full` (Tailwind), was `w-100` (Bootstrap `!important`) — #234. -->
        <div class="w-full h-96 flex justify-content-center">
          <analytics-error-message [analysisErrorState]="timeSeriesPerformanceStore.analysisErrorState"/>
        </div>
      }
    }
  }

  <canvas #revenueDoughnutChart [ngClass]="{'hidden':timeSeriesPerformanceStore.analysisErrorState!==undefined}"
          class="inline-flex w-full"></canvas>
</div>

